/* eslint-disable react-hooks/exhaustive-deps */
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import ButtonAll from "../button/Button";
import useAuthUser from "../../auth/getUser";

const JobDetails = () => {
  const { id } = useParams();
  console.log(id);
  const [jobDetails, setJobDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [totalJobs, setTotalJobs] = useState([])
  console.log(jobDetails);
  const {user} = useAuthUser();




  useEffect(() => {
    const fetchJobs = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BASE_API}/postjobs/${id}`
        );
        setJobDetails(res.data);
        setLoading(false);
        // if(res.data.postbyId){

        //   const x= await fetchTotalJobs(res?.data?.postbyId)
        //   console.log({x})
        // }
      } catch (error) {
        console.error("There was an error fetching the jobs!", error);
        Swal.fire({
          title: "Error!",
          text: "There was an error fetching the jobs",
          icon: "error",
          confirmButtonText: "OK",
        });
        setLoading(false);
      }
    };

    fetchJobs();
  }, [user]);

  useEffect(() => { 
    const fetchTotalJobs = async () => {
      if (user?._id) {
        try {
          const response = await fetch(
            `${process.env.REACT_APP_BASE_API}/postjobs?id=${jobDetails.postbyId}`
          );
          const data = await response.json();
          setTotalJobs(data);
        } catch (error) {
          console.error("Error fetching jobs:", error);
        }
      }
    };

    fetchTotalJobs();
   },[jobDetails])


  console.log("totla jobs by poster",   {totalJobs})

  console.log("job details",{ jobDetails, totalJobs });

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!jobDetails) {
    return <div>No job details found</div>;
  }

  return (
    <div className="max-w-6xl mx-auto mt-7">
      <div>
        <h3 className="text-3xl leading-[120%]">{jobDetails.job_title}</h3>
        <Link
          to={`/profile/${jobDetails.postbyId}`}
          className="mt-2 leading-[120%] text-xs text-gray-800"
        >
          By{" "}
          <span className=" text-xs leading-[120%] text-[#2792A8]">
            {" "}
            {jobDetails.postby}
          </span>
        </Link>

        <div className="flex items-center gap-3 mt-3 mb-3">
          {/* {user?.role === "job-seeker" && (
            <ButtonAll onClick={() => handleApply(jobDetails._id)}>
              Apply this Job
            </ButtonAll>
          )} */}

          {!user ? (
            <Link to="/login">
              <ButtonAll>Login to apply this job</ButtonAll>
            </Link>
          ) : (
            <>
            {user?.role === "job-seeker" &&
              <Link to={`/apply-job/${jobDetails._id}`}>
                <ButtonAll>Apply This Job</ButtonAll>
              </Link>
            }
            </>
          )}

          <button
            className="cursor-pointer md:w-40 font-medium text-xs hover:text-[#2792A8] active:opacity-30"
            onClick={() => navigator.clipboard.writeText(window.location.href)}
          >
            Copy link URL job
          </button>
        </div>

        <div>
          <div className=" flex items-center max-h-8">
            <img src="/details/1.svg" alt="" className=" w-5 h-5" />
            <span className=" textarea-md">
             Company Name: {jobDetails?.company || ""}
            </span>
          </div>

          <div className=" flex items-center max-h-8">
            {" "}
            <img src="/details/2.svg" alt="" className=" w-5 h-5" />
            <span className=" textarea-md">
             Location: {jobDetails?.location || ""}{" "}
            </span>
          </div>

          <div className=" flex items-center max-h-8">
            {" "}
            <img src="/details/3.svg" alt="" className=" w-5 h-5" />
            <span className=" textarea-md">
              Industry: {jobDetails?.industry || ""}{" "}
            </span>
          </div>

          <div className=" flex items-center max-h-8">
            {" "}
            <img src="/details/4.svg" alt="" className=" w-5 h-5" />
            <span className=" textarea-md">
              {jobDetails?.size_of_company || "Size Of Company"} stuff{" "}
            </span>
          </div>

          <div className=" flex items-center max-h-8">
            {" "}
            <img src="/details/5.svg" alt="" className=" w-5 h-5" />
            <span className=" textarea-md">
             Job Posted: {totalJobs?.length || "0"}{" "}
            </span>
          </div>

          <div className=" flex items-center max-h-8">
            {" "}
            <img src="/details/6.svg" alt="" className=" w-5 h-5" />
            <span className=" textarea-md">
              {" "}
              Job Filled: {totalJobs?.length || "0"}{" "}
            </span>
          </div>
        </div>
      </div>

      <div className="mt-6">
        <h2 className="text-4xl font-semibold text-center text-[#196D7C] leading-[120%] my-14">
          Job Details
        </h2>
        <div className="grid lg:grid-cols-2 grid-cols-1 mx-auto text-center gap-8">
          <div className=" border-2 border-gray-400 rounded-md min-h-40 flex flex-col justify-center items-center gap-y-4">
            <h5 className=" text-xl leading-[120%] ">Employment</h5>
            <h3 className="text-3xl font-semibold text-[#20A3BA] leading-[120%] capitalize">
              {jobDetails.job_type}
            </h3>
          </div>

          <div className=" border-2 border-gray-400 rounded-md min-h-40 flex flex-col justify-center items-center gap-y-4">
            <h5 className=" text-xl leading-[120%] ">Hours per weeks</h5>
            <h3 className="text-3xl font-semibold text-[#20A3BA] leading-[120%] capitalize">
              {jobDetails.hour_per_week} /Hour
            </h3>
          </div>

          <div className=" border-2 border-gray-400 rounded-md min-h-40 flex flex-col justify-center items-center gap-y-4">
            <h5 className=" text-xl leading-[120%] ">Expertise Level</h5>
            <h3 className="text-3xl font-semibold text-[#20A3BA] leading-[120%] capitalize">
              {jobDetails.experience_level}
            </h3>
          </div>

          <div className=" border-2 border-gray-400 rounded-md min-h-40 flex flex-col justify-center items-center gap-y-4">
            <h5 className=" text-xl leading-[120%] ">Job rate per hour</h5>
            <h3 className="text-3xl font-semibold text-[#20A3BA] leading-[120%] ">
              { (jobDetails?.salary) || "$8/hr - $9/hr" }
            </h3>
          </div>
        </div>
      </div>
      <div className="!p-4 bg-[#ecf7f4] w-full my-16 rounded-md bgw">
        <h2 className="text-3xl font-semibold text-center my-5">
          Job Description
        </h2>
        <div
          className="prose w-full p-4 custom-prose texw bgw"
          style={{ width: "100%" }}
          dangerouslySetInnerHTML={{ __html: jobDetails.job_description }}
        />
        <div
          className="prose w-full p-4 custom-prose textw"
          style={{ width: "100%" }}
          dangerouslySetInnerHTML={{ __html: jobDetails.job_requirements }}
          
        />
      </div>
    </div>
  );
};

export default JobDetails;
